import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationSearchForm } from 'src/app/models/notification-search.model';
import { environment } from 'src/environments/environment';
import { ClassNotification, NotificationModel } from '../../models/class-notification.model';
import { NotificationInterface } from './notification.interface';


@Injectable({
  providedIn: 'root'
})
export class NotificationService implements NotificationInterface { 
  constructor(private httpClient: HttpClient) { }

  SendNotification(notification: NotificationModel): Observable<any> {
    return this.httpClient.post<NotificationModel>(environment.apiBaseUrl + `notification/SendNotification`, notification);
  }

  GetNotifications(courseId: string): Observable<ClassNotification[]> {
    if (!courseId) courseId = '';
    return this.httpClient.get<ClassNotification[]>(environment.apiBaseUrl + `notification/GetNotifications/${courseId}`);
  }

  SearchNotifications(notificationSearchForm: NotificationSearchForm): Observable<ClassNotification[]> {
    return this.httpClient.post<ClassNotification[]>(environment.apiBaseUrl + `notification/SearchNotifications`, notificationSearchForm);
  }

  MarkNotificationAsReadOrDelete(classNotificatoinId: string, isDelete: boolean = false): Observable<Boolean> {
    return this.httpClient.get<Boolean>(environment.apiBaseUrl + `notification/MarkNotificationAsReadOrDelete/${classNotificatoinId}/${isDelete}`);
  }

  MarkAllNotificationsAsReadOrDeleteForTp(isDelete: boolean = false): Observable<Boolean> {
    return this.httpClient.get<Boolean>(environment.apiBaseUrl + `notification/MarkAllNotificationsAsReadOrDeleteForTp/${isDelete}`);
  }

  SearchWorkerNotifications(notificationSearchForm: NotificationSearchForm): Observable<ClassNotification[]> {
    return this.httpClient.post<ClassNotification[]>(environment.apiBaseUrl + `notification/SearchWorkerNotifications`, notificationSearchForm);
  }
}
